import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { Formik } from "formik";
import { Link, useLocation } from "react-router-dom";
import { resetPassword } from '../../crud/auth.crud';
import BetterAlerts from "../../components/BetterAlerts";
import { useTranslation } from "react-i18next";
import { toAbsoluteUrl } from "../../utils/Utils";

function ResetPassword({ match }) {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [success_list, setSuccessList] = useState([]);
	const [error_list, setErrorList] = useState([]);
	const { search } = useLocation();

	const regexEmail = /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/;

	useEffect(() => {
		const query = new URLSearchParams(search);
		let token = query.get('token');

		if (!token) {
			window.location.href = '/auth';
		}
	}, []);

	const validateForm = values => {
		let map = new Map();

		map.set('email', t("Fields.email.title"));
		map.set('password', t("Fields.password.title"));
		map.set('passwordConfirm', t("Fields.passwordConfirm.title"));

		const errors = {};

		for (let [key, value] of map) {
			if (!values[key]) {
				errors[key] = t("Fields.validation.required", { fieldName: value });;
			} else if (key === 'email' && !regexEmail.test(values[key])) {
				errors[key] = t("Fields.validation.email");
			}
		}

		return errors;
	};

	const onSubmit = values => {
		const query = new URLSearchParams(search);
		let token = query.get('token');

		if (values.password.length < 6) {
			setErrorList([t("ResetPassword.validation.minChar")]);
			return;
		}

		if (values.password !== values.passwordConfirm) {
			setErrorList([t("ResetPassword.validation.notEqual")]);
			return;
		}

		setLoading(true);

		let data = {
			token: token,
			email: values.email,
			password: values.password,
			password_confirmation: values.passwordConfirm
		}

		resetPassword(data).then(res => {
			if (res?.data?.errors) {
				setErrorList([res.data.errors[0]]);
			} else {
				setSuccessList([t("ApiCalls.resetPassword.success")]);
				setTimeout(() => {
					window.location.href = '/auth';
				}, 2000);
			}

			setLoading(false);
		}).catch(() => {
			setErrorList([t("ApiCalls.resetPassword.error")]);
		});
	};

	const getInitialValues = () => {
		return {
			email: '',
			password: '',
			passwordConfirm: '',
		};
	}

	return (
		<div className='body-reset-password' >
			<div className='card-reset-password' >
				<Formik initialValues={getInitialValues()} validate={values => validateForm(values)} onSubmit={(values) => onSubmit(values)}>
					{({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
						<form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
							<div style={{ display: 'flex', justifyContent: 'center' }} className='row'>
								<Link to="/" className="kt-login__logo" style={{ display: 'flex', justifyContent: 'center', marginBottom: '50px' }}>
									<img alt="Logo" src={toAbsoluteUrl("/images/logo-dark.png")} style={{ maxWidth: '70%', height: 'auto' }} />
								</Link>
							</div>

							<div className="row">
								<div className='col-sm-12'>
									<center><h3 style={{ marginBottom: '25px' }} className="kt-login__title">{t("ResetPassword.title")}</h3></center>
									<center><h4 style={{ marginBottom: '40px' }} className="kt-login__subtitle">{t("ResetPassword.text1")}<br />{t("ResetPassword.text2")}</h4></center>
								</div>

								<div style={{ marginBottom: '25px' }} className='col-sm-12'>
									<BetterAlerts errors={error_list} success={success_list} />
								</div>

								<div className="col-sm-12">
									<div className="form-group fg-line">
										<TextField name="email" label={`${t("Fields.email.title")} *`} margin="normal" variant="outlined"
											onBlur={handleBlur} onChange={handleChange} value={values.email}
											helperText={touched.email && errors.email} type='email'
											error={Boolean(touched.email && errors.email)} />
									</div>
								</div>

								<div className="col-sm-12">
									<div className="form-group fg-line">
										<TextField name="password" label={`${t("Fields.password.title")} *`} margin="normal" variant="outlined"
											onBlur={handleBlur} onChange={handleChange} value={values.password}
											helperText={touched.password && errors.password} type='password'
											error={Boolean(touched.password && errors.password)} />
									</div>
								</div>

								<div className="col-sm-12">
									<div className="form-group fg-line">
										<TextField name="passwordConfirm" label={`${t("Fields.passwordConfirm.title")} *`} margin="normal" variant="outlined"
											onBlur={handleBlur} onChange={handleChange} value={values.passwordConfirm}
											helperText={touched.passwordConfirm && errors.passwordConfirm} type='password'
											error={Boolean(touched.passwordConfirm && errors.passwordConfirm)} />
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-sm-12">
									<center>
										<button type="submit" disabled={loading} className="btn btn-success btn-bold">
											<i className={`margin-icon ${loading ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>{t("Buttons.confirm")}
										</button>
									</center>
								</div>
							</div>
						</form>
					)}
				</Formik>
			</div>
		</div>
	);
}

export default connect(null, auth.actions)(ResetPassword)

